import { ArrowRight, GitFork } from "lucide-react";
import { Link } from "react-router-dom";

import { Button } from "@/components/ui/button";

const platformFacts = [
  "4 self-serve checks",
  "3 managed outcomes",
  "Cited evidence",
  "One audit trail",
];

export function TRDRHeroSection() {
  return (
    <section className="relative min-h-screen overflow-hidden bg-[#00261C]">
      <div className="absolute inset-0 z-0">
        <img
          src="https://images.unsplash.com/photo-1494412574643-35d324698b93?q=80&w=2070&auto=format&fit=crop"
          alt=""
          className="h-full w-full object-cover opacity-15"
        />
        <div className="absolute inset-0 bg-[#00261C]/90 mix-blend-multiply" />
        <div className="absolute inset-0 bg-gradient-to-b from-[#00261C] via-[#00261C]/75 to-[#00261C]" />
      </div>

      <div className="absolute inset-0 z-0 bg-[linear-gradient(rgba(178,242,115,0.03)_1px,transparent_1px),linear-gradient(90deg,rgba(178,242,115,0.03)_1px,transparent_1px)] bg-[size:100px_100px] [mask-image:radial-gradient(ellipse_at_center,black_40%,transparent_72%)]" />
      <div className="absolute left-1/2 top-24 z-0 h-[420px] w-[720px] -translate-x-1/2 rounded-full bg-[#B2F273]/10 blur-[140px]" />

      <div className="container relative z-10 mx-auto px-4 pb-20 pt-40 sm:px-6 md:pt-48 lg:px-8">
        <div className="mx-auto max-w-6xl">
          <div className="mb-8 flex justify-center">
            <div className="inline-flex items-center gap-2 rounded-full border border-[#B2F273]/25 bg-[#B2F273]/10 px-4 py-2">
              <GitFork className="h-4 w-4 text-[#B2F273]" />
              <span className="font-mono text-xs uppercase tracking-[0.16em] text-[#B2F273]">
                One trade intelligence platform. Two delivery models.
              </span>
            </div>
          </div>

          <div className="mx-auto max-w-5xl text-center">
            <h1 className="font-display text-4xl font-bold leading-[1.02] tracking-tight text-white sm:text-6xl lg:text-7xl">
              Trade compliance software for repeatable checks.
              <span className="mt-2 block text-[#B2F273]">
                Managed intelligence for complex decisions.
              </span>
            </h1>
            <p className="mx-auto mt-8 max-w-3xl text-lg leading-relaxed text-[#EDF5F2]/70 sm:text-xl">
              Run defined checks yourself and receive cited, exportable results. When evidence is
              fragmented and the work requires investigation, Enso operates the same rules and
              evidence platform as a managed engagement.
            </p>

            <div className="mt-10 flex flex-col justify-center gap-4 sm:flex-row">
              <Button
                asChild
                size="lg"
                className="h-auto border-none bg-[#B2F273] px-8 py-6 text-base font-bold text-[#00261C] hover:bg-[#a3e662]"
              >
                <Link to="/#self-serve">
                  Explore self-serve checks
                  <ArrowRight className="ml-2 h-5 w-5" />
                </Link>
              </Button>
              <Button
                asChild
                size="lg"
                variant="outline"
                className="h-auto border-[#EDF5F2]/25 bg-transparent px-8 py-6 text-base text-white hover:border-[#B2F273]/60 hover:bg-[#EDF5F2]/5 hover:text-[#B2F273]"
              >
                <Link to="/contact">Discuss a managed engagement</Link>
              </Button>
            </div>
          </div>

          <div className="mx-auto mt-16 grid max-w-4xl grid-cols-2 border-y border-[#EDF5F2]/10 md:grid-cols-4">
            {platformFacts.map((fact, index) => (
              <div
                key={fact}
                className={[
                  "flex min-h-24 items-center justify-center px-4 text-center",
                  index > 0 ? "border-l border-[#EDF5F2]/10" : "",
                  index === 2 ? "border-l-0 border-t border-[#EDF5F2]/10 md:border-l md:border-t-0" : "",
                  index === 3 ? "border-t border-[#EDF5F2]/10 md:border-t-0" : "",
                ].join(" ")}
              >
                <p className="font-mono text-xs uppercase tracking-[0.14em] text-[#EDF5F2]/65">
                  {fact}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
